<template>
  <div class="wrap">
    <div id="editor" class="editor"></div>
  </div>
</template>
<script>
import Editor from 'wangeditor'
import db from '@//services/localstorage'
export default {
  data() {
    return {
      editor: '',
      info_: null,
     
    }
  },
  props: {
    isClear: {
      type: Boolean,
      default() {
        return false
      }
    },
    content: {
      type: String,
      default() {
        return ''
      }
    }
  },
  model: {
    prop: 'content',
    event: 'change'
  },
  watch: {
    isClear(val) {
      if (val) {
        this.editor.txt.clear()
        this.info_ = null
      }
    },
    content(value) {
      if (value !== this.editor.txt.html()) {
          this.editor.txt.html(this.content)
        }
    }
  },
  methods: {
    get() {
      var  baseUrl= this.$getBaseUrl()

      this.editor = new Editor('#editor')
      this.editor.config.showLinkImg = false //禁止上传网络图片
      this.editor.config.uploadFileName = 'file' // formdata中的name属性
      this.editor.config.uploadImgServer = baseUrl+'/upload/upload' // 上传图片的接口地址
      this.editor.config.uploadImgMaxSize = 10 * 1024 * 1024 // 将图片大小限制为 10M
      this.editor.config.uploadImgTimeout = 10 * 60 * 1000 // 设置超时时间
      this.editor.config.uploadImgHeaders = {
        Authorization: 'Bearer ' + db.get('token') // 设置请求头
      }
      this.editor.config.uploadImgHooks = {
        // 图片上传并返回结果，但图片插入错误时触发
        fail: function (xhr, editor, result) {
          // console.log(result)
        },
        success: function (xhr, editor, result) {
          // 图片上传并返回结果，图片插入成功之后触发
          // console.log(result, 'success')
        },
        customInsert: function (insertImg, result, editor) {
       
          // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
          // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果
          // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
          var url =baseUrl+result.data;

          insertImg(url);

          // result 必须是一个 JSON 格式字符串！！！否则报错

        }
      }
      this.editor.config.onchange = html => {
        // console.log(html)
        this.info_ = html
        this.$emit('change', this.info_)
      }
      this.editor.create() // 创建富文本实例
      if (!this.content) {
        this.editor.txt.html('')
      } else {
        this.editor.txt.html(this.content)
      }
    }
  },
  mounted() {
    this.get()
  },

}
</script>

<style>

</style>
